export default "__VITE_PUBLIC_ASSET__1921a918__"